import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader, getCurrentYear } from "../Helpers";
import logo from "../assets/logo.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function FooterKabalenzi() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    // any future initializations
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <footer
      className="text-light pt-5"
      style={{
        background: "linear-gradient(160deg, #0f1b12 0%, #16281b 55%, #1e3323 100%)",
        borderTop: "3px solid #ffc107",
      }}
    >
      <div className="container">
        <div className="row g-4 align-items-start pb-4">
          <div className="col-lg-4 col-md-6">
            <img
              src={logo}
              alt="Kinemo Agro Logo"
              style={{ height: "60px", filter: "brightness(0) invert(1)" }}
              className="mb-3"
            />
            <p className="mb-3" style={{ fontSize: "14px", lineHeight: "1.7" }}>
              Kinemo Agro Seeds and Chemical Traders Co. Ltd delivers quality seeds, agrochemicals,
              poultry feeds, and day-old chicks while empowering farmers with training and technical support.
            </p>
            <div className="d-flex gap-3">
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="text-light fs-5">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="text-light fs-5">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className="text-light fs-5">
                <FaLinkedinIn />
              </a>
              <a href="https://wa.me/255784587121" target="_blank" rel="noreferrer" className="text-light fs-5">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="col-lg-2 col-md-6">
            <h6 className="text-uppercase fw-bold mb-3" style={{ color: "#ffc107", fontSize: "16px" }}>
              Quick Links
            </h6>
            <ul className="list-unstyled">
              {[
                { key: "", label: "Home" },
                { key: "about_us", label: "About Us" },
                { key: "services", label: "Services" },
                { key: "contact_us", label: "Contact Us" },
              ].map((link) => (
                <li key={link.key} className="mb-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      appContext.navTo({ item: link.key });
                    }}
                    className="text-light text-decoration-none"
                    style={{ fontSize: "14px" }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="text-uppercase fw-bold mb-3" style={{ color: "#ffc107", fontSize: "16px" }}>
              Office Locations
            </h6>
            <div style={{ fontSize: "14px", lineHeight: "1.7" }}>
              <div className="d-flex align-items-start gap-2 mb-2">
                <FaMapMarkerAlt className="mt-1 text-warning" />
                <div>
                  <strong>Corporate Office</strong>
                  <div>Nzovwe Tanzam Highway, Block No. 779 near CF Fuel Station</div>
                  <div>Mbeya, Tanzania</div>
                </div>
              </div>
              <div className="d-flex align-items-start gap-2">
                <FaMapMarkerAlt className="mt-1 text-warning" />
                <div>
                  <strong>Factory</strong>
                  <div>Ikumbi Villages close to Songwe Airport</div>
                  <div>Mbeya, Tanzania</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="text-uppercase fw-bold mb-3" style={{ color: "#ffc107", fontSize: "16px" }}>
              Contact
            </h6>
            <div style={{ fontSize: "14px", lineHeight: "1.8" }}>
              <div className="mb-2 d-flex align-items-center gap-2">
                <FaEnvelope className="text-warning" />
                <a href="mailto:info@kinemoagro.com" className="text-light text-decoration-none">
                  info@kinemoagro.com
                </a>
              </div>
              <div className="mb-2 d-flex align-items-center gap-2">
                <FaPhoneAlt className="text-warning" />
                <a href="tel:+255784587121" className="text-light text-decoration-none">
                  +255 784 587 121
                </a>
              </div>
              <div className="mb-2 d-flex align-items-center gap-2">
                <FaWhatsapp className="text-warning" />
                <a href="https://wa.me/255784587121" target="_blank" rel="noreferrer" className="text-light text-decoration-none">
                  Chat on WhatsApp
                </a>
              </div>
              <div className="text-light">www.kinemoagro.com</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)" }}>
        <div className="container">
          <div className="row align-items-center py-3">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0" style={{ fontSize: "14px" }}>
                &copy; {getCurrentYear()} Kinemo Agro Seeds and Chemical Traders Co. Ltd. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p className="mb-0" style={{ fontSize: "14px" }}>
                Website designed by{" "}
                <a
                  href="http://werenium.com"
                  target="_blank"
                  rel="noreferrer"
                  className="text-light text-decoration-none fw-bold"
                >
                  Werenium Technologies
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
